import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingApprove from "../BookingApprove";

const CompletedBooking = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking List" />
      <BookingApprove status={5}/>
    </MasterLayout>
  );
};

export default CompletedBooking;
